// @ actions
const { validateAndExecute } = require('../signaturePattern');

const {
    RENEW_IMPOSITION_INTEREST_REQUEST,
    RENEW_IMPOSITION_INTEREST_SUCCESS,
    RENEW_IMPOSITION_INTEREST_FAILURE,

    RENEW_IMPOSITION_INTEREST_RESET,
    RENEW_IMPOSITION_INTEREST_SET_VISIBLE_STEP,
    RENEW_IMPOSITION_INTEREST_VALIDATE,
    RENEW_IMPOSITION_INTEREST_SHOW_CANCEL_MODAL,
} = require('constants/contactCenter/actionTypes');

const apiRequestHelper = require('utilities/APIRequestHelper');

const renewImpositionInterestInProgress = () => ({
    type: RENEW_IMPOSITION_INTEREST_REQUEST
});

const renewImpositionInterestSuccess = payload => ({
    type: RENEW_IMPOSITION_INTEREST_SUCCESS,
    payload
});

const renewImpositionInterestFailure = error => ({
    type: RENEW_IMPOSITION_INTEREST_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: RENEW_IMPOSITION_INTEREST_RESET
});

const setVisibleStep = step => ({
    type: RENEW_IMPOSITION_INTEREST_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: RENEW_IMPOSITION_INTEREST_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const validateStep = step => ({
    type: RENEW_IMPOSITION_INTEREST_VALIDATE,
    payload: {
        step
    }
});

const renewImpositionInterestRequest = ( impositionId, contractNumber, product, isRenewal, dataToken) => (dispatch, getState) => {
    const { impositionInterestRenewal } = getState();

    if (!impositionInterestRenewal.get('isFetching')) {

        dispatch(renewImpositionInterestInProgress());

        const query = {
            contrato: {
                numerodecontrato: contractNumber,
                producto: product
            },
            dataToken,
            indCapitalizacion: 'N',
            indRenovar: isRenewal ? 'S' : 'N',
            numImposicion: impositionId
        }

        return apiRequestHelper.APIPost({
            dispatch,
            endpoint: 'renewCapitalization',
            params: {
                query
            }
        })
        .then(response => dispatch(renewImpositionInterestSuccess(response)))
        .catch(response => dispatch(renewImpositionInterestFailure(response.error)));
    }
};

const renewImpositionInterest = (impositionId, contractNumber, product, isRenewal) => (dispatch, getState) => {
    validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
        dispatch(renewImpositionInterestRequest(impositionId, contractNumber, product, isRenewal, dataToken));
    });
}

module.exports = {
    renewImpositionInterest,
    setVisibleStep,
    validateStep,
    showCancelModal,
    reset
};
